var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProject)?_c('v-chip',{staticClass:"table-label",attrs:{"small":"","label":"","dark":"","color":_vm.projectStatusColor}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.projectText)))])]):_c('v-chip',{staticClass:"table-label",attrs:{"small":"","label":"","dark":"","color":_vm.status.color}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.status.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }